document.addEventListener('alpine:init', () => {
  Alpine.store('utilities', {
    removeSectionWrapper,
    getElsFromHtmlString,
    getElFromHtmlString,
    findScrollContainer,
    checkInView,
    scrollIntoViewWithinEl,
    scrollIntoViewIfNeededWithinEl,
    getDefaultAlpineMorphLifecycleHooks
  });

  function removeSectionWrapper(htmlString) {
    var parser = new DOMParser();
    var parserDocument = parser.parseFromString(htmlString, 'text/html');

    return parserDocument.body.firstElementChild.innerHTML;
  };

  function getElsFromHtmlString(htmlString, selector) {
    var parser = new DOMParser();
    var parserDocument = parser.parseFromString(htmlString, 'text/html');

    return parserDocument.querySelectorAll(selector);
  };

  function getElFromHtmlString(htmlString, selector) {
    return getElsFromHtmlString(htmlString, selector)[0];
  };

  function findScrollContainer(el) {
    if (!el) {
      return undefined;
    }

    var parent = el.parentElement;

    while (parent) {
      var { overflow } = window.getComputedStyle(parent);

      if (overflow.split(' ').every(o => o === 'auto' || o === 'scroll')) {
        return parent;
      }

      parent = parent.parentElement;
    }

    return document.documentElement;
  };

  function checkInView(container, element) {
    var cLeft = container.scrollLeft;
    var cRight = cLeft + container.clientWidth;

    var eLeft = element.offsetLeft;
    var eRight = eLeft + element.clientWidth;

    return (eLeft >= cLeft && eRight <= cRight);
  };

  function scrollIntoViewWithinEl(el, behavior) {
    var scrollContainer = findScrollContainer(el);

    scrollContainer.scroll({ left: el.offsetLeft, behavior });
  };

  function scrollIntoViewIfNeededWithinEl(el, behavior) {
    var scrollContainer = findScrollContainer(el);

    var inView = checkInView(scrollContainer, el);

    if (inView) return;

    scrollContainer.scroll({ left: el.offsetLeft, behavior });
  };

  function getDefaultAlpineMorphLifecycleHooks() {
    return {
      updating(el, toEl, childrenOnly, skip) {
        if (el.hasAttribute && el.hasAttribute('data-alpine-morph-full-replace')) {
          skip();
          el.replaceWith(toEl);
        }
      }
    };
  };
});
